<!-- Offcanvas: Add / Edit Week Color -->
<div
  class="offcanvas offcanvas-end"
  style="width: 35%"
  tabindex="-1"
  id="addColoroffcanvas"
  aria-labelledby="addColorcanvasLabel"
  data-bs-backdrop="static"
  #addColorOffcanvas
>
  <div class="offcanvas-header px-0 pt-4">
    <h5 class="mb-0">{{ isEditMode ? 'Edit Week Color' : 'Add New Week Color' }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="clearForm()"></button>
  </div>

  <div class="offcanvas-body px-0 pb-0">
    <div class="modal-content">
      <div class="custom-modal-body modal-body">
        <form [formGroup]="colorForm" class="modal-body-wraapper mt-3">

          <!-- Color Picker -->
          <div class="selector">
            <div class="custom-label mt-1">
              <label for="color1" class="form-label">Choose Color</label>
              <p>:</p>
            </div>
            <div class="input-wrapper-right">
              <div class="color-picker w-100">
                <p style="padding-left: 12px">Choose Color</p>
                <input
                  class="color1"
                  id="color1"
                  type="color"
                  formControlName="color"
                />
              </div>
              <div *ngIf="colorCtrl.invalid && colorCtrl.touched" class="invalid-feedback d-block mt-1">
                Color is required.
              </div>
            </div>
          </div>

          <!-- Color Name -->
          <div class="selector">
            <div class="custom-label mt-1">
              <label for="colorTitle" class="form-label">Color Name</label>
              <p>:</p>
            </div>
            <div class="input-wrapper-right">
              <input
                type="text"
                class="form-control w-100"
                id="colorTitle"
                placeholder="Enter Color Name"
                formControlName="displayName"
                [class.is-invalid]="displayNameCtrl.invalid && displayNameCtrl.touched"
              />
              <div *ngIf="displayNameCtrl.invalid && displayNameCtrl.touched" class="invalid-feedback d-block mt-1">
                Color name is required.
              </div>
            </div>
          </div>

          <!-- Status -->
          <div class="d-flex flex-wrap align-items-center justify-content-between">
            <div class="custom-label">
              <span>Status</span>
              <p>:</p>
            </div>
            <div class="get-status">
              <div class="form-check me-3">
                <input
                  class="form-check-input"
                  type="radio"
                  name="statusRadio"
                  id="active"
                  [checked]="statusCtrl.value === Status.Active"
                  (click)="changeStatus(true)"
                />
                <label class="form-check-label" for="active">Active</label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="statusRadio"
                  id="inactive"
                  [checked]="statusCtrl.value === Status.Inactive"
                  (click)="changeStatus(false)"
                />
                <label class="form-check-label" for="inactive">Inactive</label>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="custom-modal-footer modal-footer justify-content-end pb-2 mt-0 px-0 pt-2 d-flex" style="height: 10vh">
    <button class="btn modal-btn me-3" (click)="clearForm()">
      Cancel
    </button>
    <button
      class="btn modal-btn add-btn me-2"
      [disabled]="colorForm.invalid"
      (click)="CreateProductionCycle()"
    >
      {{ isEditMode ? 'Update' : 'Add Color' }}
    </button>
  </div>
</div>


<!-- Offcanvas: Create Schedule -->
<div
  class="offcanvas offcanvas-end"
  style="width: 35%"
  tabindex="-1"
  id="createscheduleoffcanvas"
  aria-labelledby="createschedulecanvasLabel"
  data-bs-backdrop="static"
>

  <div class="offcanvas-header px-0 pt-4">
    <h5 class="mb-0">{{ isPreviewStep ? 'Preview Schedule' : 'Generate Schedule' }}</h5>
    <button *ngIf="!isPreviewStep" type="button" class="btn-close" aria-label="Close" (click)="closeAndReset()"></button>
  </div>

  <div class="offcanvas-body px-0 pb-0">
    <div class="modal-content">
      <div class="custom-modal-body modal-body">
        <div class="modal-body-wraapper">

          <!-- Step 1: Date Selection -->
          <form *ngIf="!isPreviewStep" [formGroup]="scheduleForm" class="modal-body-wraapper">
            <div class="d-flex justify-content-between align-items-center m-2">
              <label class="form-label h-font">Schedule Start Date :</label>
              <div class="w-50">
                <div class="custom-dropdown w-100">
                  <input
                    matInput
                    class="matImput"
                    [matDatepicker]="startPicker"
                    formControlName="scheduleStartDate"
                    placeholder="MM/DD/YYYY"
                    [class.is-invalid]="scheduleStartDateCtrl.invalid && scheduleStartDateCtrl.touched"
                  />
                  <mat-datepicker-toggle class="ms-auto" matSuffix [for]="startPicker" style="flex-shrink: 0;"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                </div>
                <div *ngIf="scheduleStartDateCtrl.invalid && scheduleStartDateCtrl.touched" class="invalid-feedback d-block mt-1">
                  Start date is required.
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center m-2">
              <label class="form-label h-font">Schedule End Date :</label>
              <div class="w-50">
                <div class="custom-dropdown w-100">
                  <input
                    matInput
                    class="matImput"
                    [matDatepicker]="endPicker"
                    formControlName="scheduleEndDate"
                    placeholder="MM/DD/YYYY"
                    [class.is-invalid]="scheduleEndDateCtrl.invalid && scheduleEndDateCtrl.touched"
                  />
                  <mat-datepicker-toggle class="ms-auto" matSuffix [for]="endPicker" style="flex-shrink: 0;"></mat-datepicker-toggle>
                  <mat-datepicker #endPicker></mat-datepicker>
                </div>
                <div *ngIf="scheduleEndDateCtrl.invalid && scheduleEndDateCtrl.touched" class="invalid-feedback d-block mt-1">
                  End date is required.
                </div>
                <div *ngIf="scheduleEndDateCtrl.errors?.dateRange && scheduleEndDateCtrl.touched" class="invalid-feedback d-block mt-1">
                  End date cannot be earlier than start date.
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center m-2">
              <label class="form-label h-font">No. of Days in Cycle :</label>
              <input
                type="number"
                class="form-control w-50"
                placeholder="Enter No. of Days in Cycle"
                formControlName="daysInCycle"
                [class.is-invalid]="daysInCycleCtrl.invalid && daysInCycleCtrl.touched"
              />
              <div *ngIf="daysInCycleCtrl.invalid && daysInCycleCtrl.touched" class="invalid-feedback">
                Please enter a valid number (min 1).
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-start m-2">
              <label class="form-label h-font pt-2">Color Sequence :</label>
              <div class="color-sequence w-50">
                <ng-container *ngFor="let color of weekColorList; let last = last">
                  <span class="color-pill" [ngStyle]="{ 'background-color': color.color }">
                    {{ color.displayName }}
                  </span>
                  <span *ngIf="!last" class="arrow">→</span>
                </ng-container>
              </div>
            </div>
          </form>

          <!-- Step 2: Preview -->
          <div *ngIf="isPreviewStep">
            <div class="preview-info mb-3">
              <div class="info-row">
                <span class="info-label">Schedule Start:</span>
                <span class="info-value">{{ scheduleStartDateCtrl.value | date: 'MMM dd, yyyy' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Schedule End:</span>
                <span class="info-value">{{ scheduleEndDateCtrl.value | date: 'MMM dd, yyyy' }}</span>
              </div>
              <div class="info-row">
                <span class="info-label">Days in Cycle:</span>
                <span class="info-value">{{ daysInCycleCtrl.value }} days</span>
              </div>
              <div class="info-row">
                <span class="info-label">Total Weeks:</span>
                <span class="info-value">{{ previewScheduleList.length }} weeks</span>
              </div>
            </div>

            <div class="preview-table-container" *ngIf="previewScheduleList.length > 0">
              <table class="table table-bordered preview-table">
                <thead class="steak">
                  <tr>
                    <th>Week</th>
                    <th>Color</th>
                    <th>Week Start</th>
                    <th>Week End</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let week of previewScheduleList">
                    <td class="text-center">{{ week.weekNumber }}</td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span
                          [style.backgroundColor]="week.color"
                          class="d-flex justify-content-center align-items-center"
                          style="
                            border-radius: 18px;
                            height: 29px;
                            border: 1px solid #d8d8d8;
                            width: 98%;
                            font-weight: 500;
                          "
                        >
                          {{ week.displayName }}
                        </span>
                      </div>
                    </td>
                    <td>{{ week.startDate | date: 'MM /dd/ yyyy' }}</td>
                    <td>{{ week.endDate | date: 'MM /dd/ yyyy' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div *ngIf="previewScheduleList.length === 0" class="empty-state text-center py-5">
              <p class="text-muted">No preview available. Please generate a schedule.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="custom-modal-footer modal-footer justify-content-end pb-2 mt-0 px-0 pt-2" style="height: 10vh">
    <ng-container *ngIf="!isPreviewStep">
      <button
        class="btn add-btn me-2"
        [disabled]="scheduleForm.invalid"
        (click)="PreviewProductionCycleSchedule()"
      >
        Preview
      </button>
    </ng-container>

    <ng-container *ngIf="isPreviewStep">
      <button class="btn modal-btn me-2" (click)="backToDatePicker()" aria-label="Back to date picker">Back</button>
      <button class="btn modal-btn add-btn" style="width: 204px;" (click)="AddProductionCycleSchedule()">
        Confirm & Generate
      </button>
    </ng-container>
  </div>
</div>

<!-- Confirmation Dialog Modal -->
<div class="modal fade" id="confirmationDialog" aria-hidden="true" aria-labelledby="confirmationDialogLabel" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header" *ngIf="deleteButtonClickedWithSelection">
        <h5>Delete</h5>
      </div>
      <div class="modal-header" *ngIf="!deleteButtonClickedWithSelection">
        <h5>No Record Selected !</h5>
      </div>

      <div class="modal-body" *ngIf="deleteButtonClickedWithSelection">
        <div class="modal-body-wraapper">
          <p>Are you sure you want to delete "{{ colorName }}"?</p>
          <p class="fw-bold mt-3">Once deleted, all the saved data will get deleted.</p>
        </div>
      </div>
      <div class="modal-body" *ngIf="!deleteButtonClickedWithSelection">
        <div class="modal-body-wraapper">
          <p>No Record Selected! Please select one or more records to delete.</p>
        </div>
      </div>
      <div class="custom-modal-footer modal-footer">
        <button class="btn modal-btn me-2" data-dismiss="modal" aria-label="Close" #modalConfirmCloseButton (click)="onConfirmationCancel()">Close</button>
        <button class="btn modal-btn" data-dismiss="modal" aria-label="Close" *ngIf="deleteButtonClickedWithSelection" style="background-color: rgb(23, 95, 145); color: white; width: 140px;" (click)="deleteWeekColor(deleteParameter)">Yes, Delete</button>
      </div>
    </div>
  </div>
</div>